import { createContext, useContext } from 'react'

import { ClusterComputed } from '~/hooks/state'

import {
  StmtPlanDetailParams,
  DetailUrlState,
  StmtListParams,
  StmtPlansParams,
  StatementModel,
  SlowQueryListParams,
  SlowQueryModel,
  SlowQueryDetailUrlState
} from './type'

export interface IStatementDataSource {
  getStmtKinds(): Promise<string[]>

  getStmtList(reqParams: StmtListParams): Promise<StatementModel[]>

  getStmtPlans(reqParams: StmtPlansParams): Promise<StatementModel[]>

  getStmtPlanDetail(reqParams: StmtPlanDetailParams): Promise<StatementModel>

  getStmtSlowQueryList(
    reqParams: SlowQueryListParams
  ): Promise<SlowQueryModel[]>
}

export interface IStatementEvent {
  gotoDetail: (params: DetailUrlState) => void
  backFromDetail: () => void

  gotoSlowQueryDetail: (params: SlowQueryDetailUrlState) => void
}

export interface IStatementContext {
  cfg: {
    clusterId: string
    computed: ClusterComputed
  }
  ds: IStatementDataSource
  event: IStatementEvent
}

export const StatementContext = createContext<IStatementContext | null>(null)

export const StatementProvider = StatementContext.Provider

export const useStatementContext = () => {
  const statementCtx = useContext(StatementContext)
  if (statementCtx === null) {
    throw new Error('StatementContext must not be null')
  }
  return statementCtx
}
